import axios from "axios";

export const getBackendBaseURL = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://apiv2.growezy.club/";
  } else {
    return "http://localhost:3001/";
  }
};

export default axios.create({
  baseURL: getBackendBaseURL(),
});
